export const createStyles = (theme) => {
  const isDark = theme.name === 'dark';
  const pageBackground = isDark
    ? 'radial-gradient(circle at top left, rgba(37, 99, 235, 0.18), transparent 34%), #0f1419'
    : 'radial-gradient(circle at top left, rgba(37, 99, 235, 0.12), transparent 32%), #f5f7fa';
  const surface = isDark ? '#151b23' : '#ffffff';
  const surfaceSoft = isDark ? '#111827' : '#f8fafc';
  const border = isDark ? 'rgba(148, 163, 184, 0.18)' : 'rgba(148, 163, 184, 0.28)';
  const mutedText = isDark ? '#94a3b8' : '#64748b';

  return {
    wrap: {
      padding: 24,
      paddingTop: 88,
      background: pageBackground,
      minHeight: '100vh'
    },

    content: {
      maxWidth: 1600,
      margin: '0 auto'
    },

    title: {
      color: theme.toolbar.text,
      marginTop: 0,
      marginBottom: 18,
      fontSize: 30,
      fontWeight: 800,
      letterSpacing: 0
    },

    card: {
      border: `1px solid ${border}`,
      borderColor: border,
      background: surface,
      color: theme.toolbar.buttonText,
      borderRadius: 8,
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      cursor: 'pointer',
      transition: 'transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease',
      boxShadow: 'none'
    },

    cardHover: {
      background: surface,
      borderColor: '#2563eb',
      transform: 'translateY(-4px)',
      boxShadow: isDark ? '0 18px 42px rgba(0, 0, 0, 0.32)' : '0 18px 42px rgba(15, 23, 42, 0.12)'
    },

    btn: {
      background: surface,
      color: theme.toolbar.buttonText,
      border: `1px solid ${border}`,
      borderRadius: 8,
      padding: '9px 12px',
      cursor: 'pointer',
      fontWeight: 700,
      transition: 'background-color 160ms ease, border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease'
    },

    primaryBtn: {
      background: '#2563eb',
      color: '#ffffff',
      border: '1px solid #2563eb',
      borderRadius: 8,
      padding: '9px 14px',
      cursor: 'pointer',
      fontWeight: 700,
      transition: 'background-color 160ms ease, border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease',
      boxShadow: 'none'
    },

    searchInputStyle: {
      width: '100%',
      maxWidth: 420,
      padding: 11,
      borderRadius: 8,
      border: `1px solid ${border}`,
      background: surface,
      color: theme.toolbar.text,
      outline: 'none',
      marginRight: 8
    },

    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: 16
    },

    meta: {
      fontSize: 12,
      color: mutedText
    },

    name: {
      fontWeight: 700,
      color: theme.toolbar.text,
      fontSize: 16
    },

    fieldLabel: {
      fontSize: 12,
      color: mutedText
    },

    fieldValue: {
      fontSize: 14,
      color: theme.toolbar.text
    },

    moduleCard: {
      border: `1px solid ${border}`,
      background: surfaceSoft,
      borderRadius: 8,
      padding: 10,
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  };
};

export const createKindBadge = (kindSlug, kinds, theme) => {
  const kind = kinds?.find(k => k.slug === kindSlug);
  const color = kind?.color;
  const isDark = theme.name === 'dark';

  if (color) {
    return {
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      background: color + (isDark ? '33' : '22'),
      color: color,
      border: `1px solid ${color}55`
    };
  }

  // Fallback palette by hash
  const hash = (kindSlug || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const palettes = [
    { bg: isDark ? '#1e3a5f' : '#dbeafe', text: isDark ? '#60a5fa' : '#1e40af' },
    { bg: isDark ? '#1e4d2b' : '#d1fae5', text: isDark ? '#4ade80' : '#065f46' },
    { bg: isDark ? '#4d2d1e' : '#ffedd5', text: isDark ? '#fb923c' : '#9a3412' },
    { bg: isDark ? '#3b1e4d' : '#ede9fe', text: isDark ? '#c084fc' : '#6b21a8' },
    { bg: isDark ? '#1e3b4d' : '#e0f2fe', text: isDark ? '#38bdf8' : '#075985' },
  ];
  const p = palettes[hash % palettes.length];
  return {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 4,
    fontSize: 11,
    fontWeight: 600,
    background: p.bg,
    color: p.text
  };
};
